import { Inject, InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
    [environment: string]: any;
}

export const ENVIRONMENT_CONFIG = new InjectionToken('environment');

export interface IPiwikConfig {
    scriptSrc: string;
    trackUrl: string;
    trackingActivated: boolean;
    siteId: string;
    disclaimerCookie: {
        name: string;
        accepted: string;
        denied: string;
    };
}

interface PiwikLibConfig {
    baseUrl: string;
    siteId: string;
    activated: boolean;
}

// eslint-disable-next-line max-classes-per-file
export class LibConfig {
    production: boolean;
    backend: {
        apiHost: string;
    };
    headerFooter: {
        baseUrl: string;
        baseUrlContent: string;
        baseUrlMetaSuche: string;
        baseUrlSuffix: string;
        forceFallback: boolean;
    };
    websso: {
        oaghost: string;
        oamhost: string;
        jwtResourceUrl: string;
        clientSecret: string;
        clientId: string;
    };
    piwik = {} as PiwikLibConfig;
    uiHost: string;

    constructor(@Inject(ENVIRONMENT_CONFIG) private environmentConfig: EnvironmentConfig) {
        Object.assign(this, environmentConfig);
    }

    getLibConfig(): LibConfig {
        return this;
    }
    getPiwikConfig() {
        const config = this.getLibConfig();
        const piwikConfig: IPiwikConfig = {
            scriptSrc: config.piwik.baseUrl + 'piwik.js',
            trackUrl: config.piwik.baseUrl + 'piwik.php',
            trackingActivated: config.piwik.activated,
            siteId: config.piwik.siteId,
            disclaimerCookie: {
                name: 'cookie_consent',
                accepted: 'accepted',
                denied: 'denied',
            },
        };

        return piwikConfig;
    }
}
